import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const BackButton = ({ className = '' }) => {
  const history = useHistory();

  return (
    <button
      onClick={() => history.goBack()}
      className={`inline-flex items-center px-3 py-2 rounded-md hover:bg-gray-100 transition-colors duration-200 ${className}`}
      aria-label="Go back"
    >
      <ArrowLeftIcon className="h-5 w-5 mr-1.5" />
      <span className="text-sm font-medium">Back</span>
    </button>
  );
};

export default BackButton;